import { UnitSystem } from '../order/UnitSystem';

export const PermitTypeValues = {
  BRIDGE_TOLL_TURNPIKE: 'Bridge,Toll,Turnpike',
  COUNTY_LOCAL: 'County/Local Permits',
  MULTI_PERMIT_PACKAGE: 'Multi-Permit Package',
  MULTI_TRIP_OS_OW: 'Multi-Trip OS/OW',
  POLICE_UTILITIES_OTHER: 'Police/Utilities/Other',
  SINGLE_TRIP_OS_OW: 'Single Trip OS/OW',
  SUPERLOAD: 'Superload',
  TEMPORARY_REGISTRATION: 'Temporary Registration',
  FUEL_TAX: 'Fuel Tax',
  PILOT_CAR_SURVEY: 'Pilot Car/Survey',
} as const;

export const PermitType = [
  PermitTypeValues.BRIDGE_TOLL_TURNPIKE,
  PermitTypeValues.COUNTY_LOCAL,
  PermitTypeValues.MULTI_PERMIT_PACKAGE,
  PermitTypeValues.MULTI_TRIP_OS_OW,
  PermitTypeValues.POLICE_UTILITIES_OTHER,
  PermitTypeValues.SINGLE_TRIP_OS_OW,
  PermitTypeValues.SUPERLOAD,
  PermitTypeValues.TEMPORARY_REGISTRATION,
  PermitTypeValues.FUEL_TAX,
  PermitTypeValues.PILOT_CAR_SURVEY,
] as const;

export const permitTypeUnit = {
  IMPERIAL: UnitSystem.IMPERIAL.toUpperCase(),
  METRIC: UnitSystem.METRIC.toUpperCase(),
} as const;

export type PermitTypeUnit =
  (typeof permitTypeUnit)[keyof typeof permitTypeUnit];
